// All rights reserved WDN.DK
if (typeof WDN === "undefined") {
  var WDN = {};
}

WDN.Tracking = (function() {
  
  var init = function() {
    window.dataLayer = window.dataLayer || [];
  }

  var config = {
    currency: Shopify.currency.active
  }

  var _eventNames = {
    atc_wishlist: 'atc_wishlist',
    atc_artwall: 'atc_artwall',
    atw: 'add_to_wishlist'
  }

  var add_to_cart = function(value, items, eventName) {
    window.dataLayer.push({
      "event" :  eventName || "add_to_cart",
      "currency": config.currency,
      "value" : value || 0
    });
  }

  var add_to_cart_wishlist = function(value, items) {
    add_to_cart(value, items, _eventNames.atc_wishlist); 
  }

  var add_to_cart_artwall = function(value, items) {
    add_to_cart(value, items, _eventNames.atc_artwall); 
  }
  
  var add_to_wishlist = function() {
    window.dataLayer.push({
      "event" :  _eventNames.atw
    });
  }


  var _events = {
    add_to_cart: add_to_cart,
    add_to_cart_wishlist: add_to_cart_wishlist,
    add_to_cart_artwall: add_to_cart_artwall,
    add_to_wishlist: add_to_wishlist
  }

  init();

  return _events;
})();


if (typeof WDN.UserCountry === "undefined") {
  WDN.UserCountry = (function () {
    var Config = {
      endpoint:
        "https://pro.ip-api.com/json/?fields=49154&key=eB09jNvtMoqlxlK",
    };
    // Public
    var get;

    get = function (callback) {
      var endpoint = Config.endpoint;
      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          var response = JSON.parse(this.responseText);
          if (response.status === "success") {
            if (typeof callback === "function") {
              callback(response.countryCode);
            }
            return;
          }
        }
      };
      xhr.open("GET", endpoint, true);
      xhr.send();
    };

    return {
      get: get,
    };
  })();
}


if (typeof WDN.Modal === "undefined") {
  WDN.Modal = (function () {
    // Global list of all modals
    // Used for easy access after initialization,
    // Without polluting global scope
    var List = {};

    // Wrapper function to test before creating a new Modal
    var Create;

    var CreateFromParent;

    // Helper functions
    var _exists, _open, _close;

    _exists = function () {
      return false;
    };

    // Factory
    var Modal = function (id, config) {
      this.id = id;

      this.config = config || false;

      if (this.config) {
        this.callbacks = this.config.callbacks;
      }

      this.selectors = {
        body: `body`,
        modal: `.WDN__Modal[data-id='${this.id}']`,
        modal_content: `.WDN__Modal[data-id='${this.id}'] .Modal__inner`,
        open: `.Modal__open[data-id='${this.id}']`,
        close: `.Modal__close[data-id='${this.id}']`,
      };

      this.nodes = {
        body: document.querySelector(this.selectors.body),
        modal: document.querySelector(this.selectors.modal),
        modal_content: document.querySelector(this.selectors.modal_content),
        open: document.querySelectorAll(this.selectors.open),
        close: document.querySelectorAll(this.selectors.close),
      };

      this.state = {
        open: "open",
        close: "closed",
      };

      // Call to init event listeners
      this.init();
    };

    // Bind event listeners on init of new modal
    Modal.prototype.init = function () {
      if (this.nodes.open) {
        this.nodes.open.forEach(function (item) {
          item.addEventListener("click", this.open.bind(this));
        }, this);
      }
      if (this.nodes.close) {
        this.nodes.close.forEach(function (item) {
          item.addEventListener("click", this.close.bind(this));
        }, this);
      }
      if (this.nodes.modal) {
        this.nodes.modal.addEventListener(
          "click",
          this.clickOutside.bind(this)
        );
      }
    };

    Modal.prototype.clickOutside = function (event) {
      if (!this.nodes.modal_content.contains(event.target)) {
        this.close();
      }
    };

    Modal.prototype.closeOnEsc = function (event) {
      if (event) {
        if (event.keyCode == "27") {
          this.close();
        }
      }
    };

    // Get state of modal
    Modal.prototype._state = function () {
      return this.nodes.modal.dataset.state;
    };

    Modal.prototype.isOpen = function () {
      return this._state() === this.state.open;
    };

    Modal.prototype.isClosed = function () {
      return this._state() === this.state.close;
    };

    // Main actions of modal
    // # Open modal
    Modal.prototype.open = function (event) {
      if (event) {
        event.preventDefault();
      }
      
      window.addEventListener("keydown", this.closeOnEsc.bind(this));

      this.nodes.modal.dataset.state = this.state.open;
      this.onOpen();
    };

    // # Close modal
    Modal.prototype.close = function (event) {
      if (event) {
        event.preventDefault();
      }

      window.removeEventListener("keydown", this.closeOnEsc);

      this.nodes.modal.dataset.state = this.state.close;
      this.onClose();
    };

    // # Toggle modal
    Modal.prototype.toggle = function () {
      // If modal is state closed
      if (this.isClosed()) {
        // Open it
        this.open();
      } else {
        // Close it
        this.close();
      }
    };

    // Callbacks
    Modal.prototype.onOpen = function () {
      this.nodes.body.classList.add("body--modal-open");
      // Call customly defined callbacks if defined
      if (this.config) {
        if (this.callbacks.open) {
          this.callbacks.open();
        }
      }
    };

    Modal.prototype.onClose = function () {
      this.nodes.body.classList.remove("body--modal-open");
      // Call customly defined callbacks if defined
      if (this.config) {
        if (this.callbacks.close) {
          this.callbacks.close();
        }
      }
    };

    // ### FACTORY
    // ### FACTORY
    // ### FACTORY
    // Globally exposed factory function
    Create = function (id, config) {
      if (!_exists()) {
        List[id] = new Modal(id, config);
      } else {
        console.warn(
          `Failed to init new Modal with ID: "${id}". Reason: Was already found.`
        );
      }
    };

    // Create multiple items at ones, by loop through
    // children Modals of passed in parent element
    CreateFromParent = function (parent, config) {
      if (parent) {
        var Items = parent.querySelectorAll(`.Modal`);
        Items.forEach(function (modal) {
          Create(modal.dataset.id, config);
        });
      }
    };

    return {
      List: List,
      Create: Create,
      CreateFromParent: CreateFromParent,
    };
  })();
}

WDN.Modal.Create("ShopSelector");

if (typeof WDN.Currencies === 'undefined') {
  
  WDN.Currencies = (function() {
    var Config;
    
    Config = {
      da: {
        countryCode: 'da',
        currencyCode: 'DKK' 
      },
      DK: {
        countryCode: 'da',
        currencyCode: 'DKK' 
      },
      en: {
        countryCode: 'en',
        currencyCode: 'EUR' 
      },
      sv: {
        countryCode: 'sv',
        currencyCode: 'SEK' 
      },
      se: {
        countryCode: 'sv',
        currencyCode: 'SEK' 
      },
      SE: {
        countryCode: 'sv',
        currencyCode: 'SEK' 
      },
      de: {
        countryCode: 'de',
        currencyCode: 'EUR'        
      },
      DE: {
        countryCode: 'de',
        currencyCode: 'EUR'        
      },
      at: {
        countryCode: 'de',
        currencyCode: 'EUR'        
      },
      AT: {
        countryCode: 'de',
        currencyCode: 'EUR'
      },
      us: {
        countryCode: 'en',
        currencyCode: 'USD'        
      },
      US: {
        countryCode: 'en',
        currencyCode: 'USD'        
      },
      fr: {
        countryCode: 'fr',
        currencyCode: 'EUR'        
      },
      FR: {
        countryCode: 'fr',
        currencyCode: 'EUR'        
      }
    }
    
    return {
      Config: Config
    }
  })();
}


if (typeof WDN.Shop === 'undefined') {
  WDN.Shop = (function() {
    var Config = {};
    var Preference = {};
    
    
    Config = {
      cookie: {
        name: 'shop_preference',
        lifetime: 1
      }
    }
    
    // bool
    Preference.exists = function() {
      return !!Cookies.getJSON(Config.cookie.name); 
    }
    
    // get it
    Preference.read = function() {
      var mes = false;
      if (Preference.exists()) {
        mes = Cookies.getJSON(Config.cookie.name);
      }
      return mes;
    }
    
    Preference.clear = function() {
     Cookies.remove(Config.cookie.name); 
    }
    
    // set it
    Preference.set = function(countryCode) {
      var obj = false;
      
      // Check if we have a config for visitors current country
      if (WDN.Currencies.Config[countryCode]) {
       	obj = WDN.Currencies.Config[countryCode];
      }
      
      if (obj) {
        Cookies.set(Config.cookie.name, obj, {
          expires: Config.cookie.lifetime 
        });
      } else {
        Cookies.set(Config.cookie_name, "not found", {
          expires: Config.cookie.lifetime
        })
      }
    }
    
    
    var Hash = {
      value: window.location.hash,
      found: false,
      name: 'no_redirect'
    }
    
    // Set bool if we found a hash telling us not to redirect, regardless
    // Used to simply set the preference, thus preventing API lookup 
    if (Hash.value.length > 1) {
      Hash.value = Hash.value.slice(1);

      if (Hash.value === Hash.name) {
        Hash.found = true;
      }
    }
    
    
    // Form
    var Form = {
      item: document.querySelector('#ShopSelectorForm')
    };
    
    Form.locale = Form.item.querySelector('[name="locale_code"]');
    Form.currency = Form.item.querySelector('[name="currency_code"]');
    
    
    Form.item.addEventListener('submit', function(e) {
      e.preventDefault();
      Form.submitCallback();
    });
    
    
    Form.submitCallback = function() {
      var countryCode = Form.locale.value;
      var currencyCode = Form.currency.value;
      
      // Update internal state
      Preference.set(countryCode);
      Form.currency.value = currencyCode;
      
      // Submit after settings preferences, to actual update country and currency
      this.item.submit();
    }

    Form.open = function() {
      WDN.Modal.List.ShopSelector.open();
    }
    
    return {
      Preference: Preference,
      Form: Form
    }
  })();
}

if (typeof WDN.InitShopSelector === 'undefined') {
  WDN.InitShopSelector = (function() {
    var _Shop = WDN.Shop;
    var _Preference = _Shop.Preference;
    var _Form = _Shop.Form;
    var _Currencies = WDN.Currencies;
    
      // If no preference found, lets redirect 'em to their right country
    if (!_Preference.read()) {
      WDN.UserCountry.get(function(countryCode) {
        var shopConfig = _Currencies.Config[countryCode];

         _Preference.set(countryCode);

        Cookies.set("shop_preference", { name: "not found" }, {
          expires: 1
        })

        if (shopConfig) {
          _Form.locale.value = shopConfig.countryCode;
          _Form.currency.value = shopConfig.currencyCode;
          if (false) { _Form.item.submit(); }
        } else {
          if (false) {
          _Form.currency.value = 'EUR';
          _Form.locale.value = 'en';
          _Form.item.submit();
          }
        }

        WDN.Modal.List.ShopSelector.open()
      });
    }
    
  })();
}